import { render } from "./RecordBook.vue?vue&type=template&id=73891859&lang=pug"
import script from "./RecordBook.vue?vue&type=script&lang=js"
export * from "./RecordBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__